var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container"
  }, [_c("div", {
    staticClass: "top-wrap"
  }), _c("div", {
    staticClass: "titleBar"
  }, [_c("div", {
    staticClass: "img-wrap",
    on: {
      click: _vm.back
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/Nav-Back.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "center"
  }, [_vm._v(_vm._s(_vm.$t("title")))]), _c("div", {
    staticClass: "img-wrap"
  })]), _c("div", {
    staticClass: "main"
  }, _vm._l(_vm.questions, function (item, index) {
    return _c("div", {
      key: item.id,
      staticClass: "item",
      on: {
        click: function click($event) {
          return _vm.toAnswer(item.id);
        }
      }
    }, [_c("div", {
      staticClass: "left"
    }, [index % 3 == 0 ? _c("img", {
      attrs: {
        src: require("../../assets/images/Qicon-1.png"),
        alt: ""
      }
    }) : _vm._e(), index % 3 == 1 ? _c("img", {
      attrs: {
        src: require("../../assets/images/Qicon-2.png"),
        alt: ""
      }
    }) : _vm._e(), index % 3 == 2 ? _c("img", {
      attrs: {
        src: require("../../assets/images/Qicon-3.png"),
        alt: ""
      }
    }) : _vm._e()]), _c("div", {
      staticClass: "right"
    }, [_c("span", {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.content))]), _c("span", {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.questionNum) + " Questions")])])]);
  }), 0)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };